import axios, { isAxiosError } from "axios";
import { Cookies } from "react-cookie";

import { env } from "@monta/env";

// * Start - monolithicClient
export const monolithicClient = axios.create({
  baseURL: `${env.API_URL}/monolithic`
});

monolithicClient.interceptors.request.use((config) => {
  const controller = new AbortController();
  config.signal = controller.signal;

  const token = new Cookies().get("accessToken");

  if (!token) {
    controller.abort();
    return config;
  }

  config.headers.Authorization = token;
  return config;
});

monolithicClient.interceptors.response.use(null, async (error) => {
  if (!isAxiosError(error)) return Promise.reject(error);

  if (error.response?.status === 401) {
    // window.location.href = "/auth";
  }

  // TODO: handle 403
  if (error.response?.status === 403) {
    console.log("403");
  }
});
// * End - monolithicClient

// * Start - gwtClient
export const gwtClient = axios.create({
  baseURL: `${env.API_URL}/`
});

gwtClient.interceptors.request.use((config) => {
  const controller = new AbortController();
  config.signal = controller.signal;

  const token = new Cookies().get("accessToken");

  if (!token) {
    controller.abort();
    return config;
  }

  config.headers.Authorization = token;
  // parameter to set for changing content type to default
  if (!config.fetchOptions?.["isJson"])
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded; charset=UTF-8";
  return config;
});

gwtClient.interceptors.response.use(null, async (error) => {
  if (!isAxiosError(error)) return Promise.reject(error);

  if (error.response?.status === 401) {
    // window.location.href = "/auth";
  }

  // TODO: handle 403
  if (error.response?.status === 403) {
    console.log("403");
  }
});
// * End - gwtClient

// * Start - nodeClient
export const nodeClient = axios.create({
  baseURL: `${env.LEGACY_APPLICATION_URL}/api`
});

nodeClient.interceptors.request.use((config) => {
  const controller = new AbortController();
  config.signal = controller.signal;

  const token = new Cookies().get("accessToken");

  if (!token) {
    controller.abort();
    return config;
  }

  config.headers.Authorization = token;
  config.headers.Accept = "application/pdf";
  return config;
});

nodeClient.interceptors.response.use(null, async (error) => {
  if (!isAxiosError(error)) return Promise.reject(error);

  if (error.response?.status === 401) {
    // window.location.href = "/auth";window.location.href = "/auth";
  }

  // TODO: handle 403
  if (error.response?.status === 403) {
    console.log("403");
  }
});
// * End - nodeClient
